import {safeLocalStorage} from '../../../util/localStorage';
import {type SortOption} from '../types';

const NAMED_WORKSPACE_SORT_OPTIONS_KEY = 'namedWorkspaceSortOptions';

export type WorkspacePreferences = {
  ownedByViewerSortOption?: SortOption;
  ownedByOthersSortOption?: SortOption;
  /** Legacy preference used as the initial value for both ownership sections. */
  sortOption?: SortOption;
  showMyViewsOnly?: boolean;
};

export const getWorkspaceSortOptions = (
  preferences: WorkspacePreferences
): {
  ownedByViewer: SortOption;
  ownedByOthers: SortOption;
} => {
  const fallback = preferences.sortOption ?? 'lastSaved';
  return {
    ownedByViewer: preferences.ownedByViewerSortOption ?? fallback,
    ownedByOthers: preferences.ownedByOthersSortOption ?? fallback,
  };
};

export const getWorkspacePreferences = (
  workspaceRef: string
): WorkspacePreferences => {
  const stored = safeLocalStorage.getItem(NAMED_WORKSPACE_SORT_OPTIONS_KEY);
  if (!stored) {
    return {};
  }
  const preferences = JSON.parse(stored);
  return preferences[workspaceRef] || {};
};

export const setWorkspacePreference = <K extends keyof WorkspacePreferences>(
  workspaceRef: string,
  key: K,
  value: WorkspacePreferences[K]
) => {
  const stored = safeLocalStorage.getItem(NAMED_WORKSPACE_SORT_OPTIONS_KEY);
  const preferences = stored ? JSON.parse(stored) : {};

  preferences[workspaceRef] = {
    ...preferences[workspaceRef],
    [key]: value,
  };

  safeLocalStorage.setItem(
    NAMED_WORKSPACE_SORT_OPTIONS_KEY,
    JSON.stringify(preferences)
  );
};
